/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendMessageBatch.defs'
export { main as default } from './sendMessageBatch.defs'
